import { generatePostBlockHTML } from '$lib/ai/post/utils/generatePostBlockHTML';
import type { MessageContent } from '@AlidaPackages/ailabs-client';
import type { PostChild } from '$lib/api/restApi';
import { parseAICopywriterResponse } from '$lib/types/AICopywriter/api';
import { isV1PostSchema, type AICopywriterPost } from '$lib/types/AICopywriter/types';

const getPostChildren = (aiCopywriterPost: AICopywriterPost) => {
	// If copywriter is using the V1 schema (required for backwards compatibility)
	// TODO: Remove this once we've fully migrated to V2 (Agent has been updated)
	// Work captured in https://alidacxm.atlassian.net/browse/HUBS-1935
	if (isV1PostSchema(aiCopywriterPost)) {
		return [
			{
				type: 'text',
				body: generatePostBlockHTML({
					type: 'paragraph',
					content: aiCopywriterPost,
				}),
				children: [],
			},
		] satisfies PostChild[];
	}

	const blocks = aiCopywriterPost.blocks;

	return blocks.map((block) => {
		return {
			type: 'text',
			body: generatePostBlockHTML(block),
			children: [],
		};
	}) satisfies PostChild[];
};

export const copywriterMessagesToPostChildren = (messages: MessageContent[]) => {
	const postMessage = messages.find((message) => message.type === 'json');

	// No json message found
	if (!postMessage) {
		return null;
	}

	const parsedPostMessage = parseAICopywriterResponse(postMessage);

	// Message is not a valid AICopywriterResponseMessage
	if (!parsedPostMessage) {
		return null;
	}

	return getPostChildren(parsedPostMessage.text.post);
};
